export class EnableRestoreAccountMetricsConfigRequest {
    'aws';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsAccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableRestoreAccountMetricsConfigRequest.attributeTypeMap;
    }
    constructor() {
    }
}
